import React from 'react'
import { Link } from 'react-router-dom'
import AndhraLogo from "../assets/Andhra-logo.png"

const Footer = () => {
  return (
    <div className="footer_container">
      <div className="footer_box">
        <div className="row">
          <div className="col-md-4">
            <div className="footer_logo">
              <a href="https://www.andhrauniversity.edu.in/" target="_blank" rel="noreferrer">
                <img src={AndhraLogo} alt="Andhra Logo" />
              </a>
            </div>
          </div>
          <div className="col-md-4">

          </div>
          <div className="col-md-4">
            <div className="footer_content">
              <p>
                Andhra University is not just one of the oldest educational institutions in the country, but is also the first to be conceived as a residential and teaching-cum-affiliating University, mainly devoted to post-graduate teaching and research.
              </p>

              <div className="website_counter">
                <img src="//www.clustrmaps.com/map_v2.png?d=pMKUr1Po7ZjpqbOtVuMDj9V1zj4b_jc-8f8VbmB9FWY&cl=ffffff" alt='counter' />
                {/* <img
                  src='//clustrmaps.com/map_v2.png?cl=c4bbbb&t=tt&d=pMKUr1Po7ZjpqbOtVuMDj9V1zj4b_jc-8f8VbmB9FWY&co=f5f5f5&ct=000000' alt="Visitor map" /> */}
              </div>


            </div>

          </div>
        </div>




      </div>

      <div className="footer_menu">
        <Link to="/acknowledgement" >Acknowledgement</Link>
        <Link to="/disclaimer" >Disclaimer</Link>
        <a href="https://clustrmaps.com/site/1bvro" target='_blank' rel="noreferrer">Website Visitors</a>
        <Link to="/contact" >Contact Us</Link>
      </div>
      <div className="copyright_container">
        <p>Copyright © 2023 Andhra University. All rights reserved.</p>
      </div>

    </div>
  );
};

export default Footer;
